import isMobile from 'ismobilejs';


jQuery(document).ready(function ($) {

    // if (isMobile.phone) {
    // $('body').addClass('is-mobile');
    $(document).on('click', '.menu-item-has-children a', function () {

        if (!$(this).closest('li').closest('ul').hasClass('sub-menu-open')) {
            $('.sub-menu-open').removeClass('sub-menu-open');
        }

        $(this).next('.sub-menu').addClass('sub-menu-open')

    })
    // } else {
    // $('body').addClass('is-desktop');
    // }

    $(document).on('click', '.header__nav', function () {
        $('body').toggleClass('open');
    });



    $(document).on('click', '.main__nav-close', function () {
        $('body').removeClass('open');
    });

    $(window).on('scroll', function () {
        if ($('.header__ad').length) {
            if ($(window).scrollTop() > $('.header__ad').outerHeight()) {
                $('body').addClass('header-ad-fixed')
            } else {
                $('body').removeClass('header-ad-fixed')
            }
        } else {
            $('body').addClass('header-no-ad-fixed');
        }

    })
})